import { Link } from "react-router-dom";
import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import { colors, fonts } from "../../../styles/variables";

export const ContentContainer = styled.div<{ isWineDetailsPage: boolean }>`
  padding: ${(props) => (props.isWineDetailsPage ? "40px 0px 40px 80px" : "32px 15px")};
  width: 100%;
  background-color: ${colors.white};
  min-height: 450px;

  ${breakpoints.smDown} {
    padding: ${(props) => props.isWineDetailsPage && "32px 15px"};
  }
`;

export const Header = styled.h2`
  font-size: 35px;
  line-height: 0.9;
  color: ${colors.black};
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 32px;
  word-break: break-word;
`;

export const CardsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row nowrap;
  overflow-x: scroll;
  ::-webkit-scrollbar,
  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    display: none;
  }
`;

export const NavigationBarWrapper = styled.div<{ isWineDetailsPage: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 20px;
  justify-content: flex-end;
  ${(props) => props.isWineDetailsPage && "margin-right: 24px"}
`;

export const SeeAllLink = styled(Link)`
  margin-right: 8px;
  font-size: 14px;
  line-height: 18px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
`;
